var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticStyle:{"text-transform":"none"},attrs:{"loading":_vm.loading,"small":"","color":"primary"},on:{"click":function($event){return _vm.action()}}},[_vm._v(" "+_vm._s(_vm.$t('text.service_report'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }